import { DIMENSION_COLORS } from '../../editor/EditorTypes';

interface DimensionSelectorProps {
  currentDimension: number;
  onDimensionChange: (dimension: number) => void;
}

export function DimensionSelector({ currentDimension, onDimensionChange }: DimensionSelectorProps) {
  return (
    <div className="dimension-selector">
      <span className="dimension-label">Dimension:</span>
      {[1, 2, 3, 4].map(dim => (
        <button
          key={dim}
          className={`dimension-btn ${currentDimension === dim ? 'active' : ''}`}
          onClick={() => onDimensionChange(dim)}
          style={{
            borderColor: DIMENSION_COLORS[dim as keyof typeof DIMENSION_COLORS],
            color: currentDimension === dim ? DIMENSION_COLORS[dim as keyof typeof DIMENSION_COLORS] : '#666'
          }}
        >
          {dim}
        </button>
      ))}
      <span className="dimension-info">
        Current: Dimension {currentDimension}
        {currentDimension === 1 && ' (Gameplay - Entities Only)'}
      </span>
    </div>
  );
}
